import { application } from "./application"

import PaymentStatusController from "./payment_status_controller"
import ShareController from "./share_controller"
import NewsletterPopupController from "./newsletter_popup_controller"
import CookieConsentController from "./cookie_consent_controller"
import DirectUploadController from "./direct_upload_controller"
import TypewriterController from "./typewriter_controller"
import ClipboardController from "./clipboard_controller"
import CartDrawerController from "./cart_drawer_controller"
import AdminNavController from "./admin_nav_controller"
import MetaEventController from "./meta_event_controller"
import SiteNavController from "./site_nav_controller"

application.register("payment-status", PaymentStatusController)
application.register("share", ShareController)
application.register("newsletter-popup", NewsletterPopupController)
application.register("cookie-consent", CookieConsentController)
application.register("direct-upload", DirectUploadController)
application.register("typewriter", TypewriterController)
application.register("clipboard", ClipboardController)
application.register("cart-drawer", CartDrawerController)
application.register("admin-nav", AdminNavController)
application.register("meta-event", MetaEventController)
application.register("site-nav", SiteNavController)
